<template>
    <div class="section-catalogBarBox">
        <div class="section-catalogBarCont">
            <div class="section-catalogBar">
                <div class="section-catalogBar__filter">
                    <div class="left">
                        <div class="provider-filter-menu">
                            <v-menu offset-y right attach=".provider-filter-menu"
                                    content-class="v-menu-select" :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="btn-select"
                                        v-bind="attrs"
                                        v-on="on">
                                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                          <path
                                              d="M10.8482 0C10.8949 0.11213 10.9883 0.235474 10.9883 0.347605C11.0117 1.07645 11 1.07645 10.4045 1.68196C9.30679 2.80326 8.19745 3.91335 7.11147 5.04587C7.0414 5.11315 7.01805 5.23649 7.01805 5.33741C7.01805 7.10907 7.01805 8.86952 7.00637 10.6412C7.00637 10.7645 6.95966 10.9439 6.87792 10.9776C6.77282 11.0224 6.59766 10.9888 6.48089 10.9215C5.73355 10.5066 4.99788 10.0693 4.25053 9.64322C4.06369 9.53109 3.98195 9.40775 3.98195 9.1947C3.99363 7.9052 3.99363 6.62691 3.98195 5.33741C3.98195 5.23649 3.9586 5.11315 3.88854 5.04587C2.60403 3.72273 1.29618 2.39959 0 1.07645C0 0.717635 0 0.358818 0 0C3.61996 0 7.22824 0 10.8482 0ZM0.490446 0.5158C0.537155 0.683996 0.537155 0.863405 0.630573 0.953109C1.84501 2.20897 3.05945 3.45362 4.28556 4.68705C4.34395 4.74312 4.44904 4.77676 4.53079 4.77676C5.17304 4.78797 5.81529 4.78797 6.44586 4.77676C6.53928 4.77676 6.66773 4.72069 6.72611 4.65342C7.9172 3.45362 9.08493 2.25382 10.276 1.06524C10.4512 0.897044 10.5096 0.728848 10.4395 0.5158C7.13482 0.5158 3.8535 0.5158 0.490446 0.5158ZM6.45754 10.316C6.45754 8.61162 6.45754 6.95209 6.45754 5.30377C5.80361 5.30377 5.17304 5.30377 4.53079 5.30377C4.53079 6.57085 4.53079 7.82671 4.53079 9.07136C4.53079 9.13864 4.5775 9.22834 4.63588 9.25077C5.23142 9.60958 5.82696 9.94597 6.45754 10.316Z"
                                              fill="white"/>
                                        </svg>
                                        {{ $t('front.provider.filter.button.provider') }}
                                        <svg width="10" height="4" viewBox="0 0 10 4" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 4L0 0L10 -1.74846e-06L5 4Z" fill="#926D20"/>
                                        </svg>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(item, index) in platforms" :key="item.id">
                                        <input class="checkbox" type="checkbox"
                                               :id="`platform-select-check-${index}`"
                                               :value="item.id"
                                               v-model="checkedPlatformsIds"
                                               @change="platformFilterChanged">
                                        <label :for="`platform-select-check-${index}`" v-text="item.title"/>
                                    </v-list-item>
                                </v-list>
                                <v-btn @click="selectAllPlatforms">{{ $t('front.provider.filter.button.select_all') }}</v-btn>
                            </v-menu>
                        </div>
                    </div>

                    <div class="right">
                        <div class="sort">
                            <div class="sort__label">{{ $t('front.game.sort.titles.sort_by') }}</div>
                            <ul>
                                <li v-for="option in sortOptions" :key="option.value" @click="sortOptionChanged(option)"
                                    :class="getSortOptionClass(option)">{{ option.name }}
                                </li>
                            </ul>
                        </div>
                        <div class="sort-games-menu">
                            <v-menu offset-y right max-width="100px" attach=".sort-games-menu"
                                    content-class="v-menu-sort">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btn-select sort-menu" v-bind="attrs" v-on="on">
                                        {{ $t('front.game.sort.button.sort_by') }}
                                        <svg width="10" height="4" viewBox="0 0 10 4" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 -0.000279474L12 5.14258L0 5.14258L6 -0.000279474Z" fill="#926D20"/>
                                        </svg>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="option in sortOptions" :key="option.value"
                                                 :class="getSortOptionClass(option)" @click="sortOptionChanged(option)">
                                        {{ option.name }}
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiData from "../../../../src/mixins/apiData";
import {VMenu} from 'vuetifyComponents/VMenu'; // alias

export default {
    name: "CatalogBarWithProviderFilter",

    components: { VMenu },

    props: ['sortOptions', 'vendorPlatformIds'],

    mixins: [apiData],

    data: function () {
        return {
            selectedSortOption: this.sortOptions[0],
            checkedPlatformsIds: [],
        };
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    computed: {
        platforms(){
            return this.$store.state.baseDataGamePlatforms.filter(platform => this.vendorPlatformIds.includes(platform.id));
        },
    },

    methods: {
        fetchData(){
            return this.$store.dispatch('FETCH_BASE_DATA_GAME_PLATFORMS', this.createApiData());
        },

        selectAllPlatforms() {
            this.checkedPlatformsIds = this.platforms.map(platform => platform.id);

            this.platformFilterChanged();
        },

        platformFilterChanged() {
            this.$emit('platformFilterChanged', this.checkedPlatformsIds);
        },

        sortOptionChanged(option) {
            this.selectedSortOption = option;

            this.$emit('sortOptionChanged', option.value);
        },

        getSortOptionClass(option) {
            return option.value === this.selectedSortOption.value ? 'active' : '';
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/CatalogBarWithProviderFilter"
</style>
